import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';
import GeoUtils from '../geoUtils.js';

export default class NodeBend extends Node
{
	static AXIS_TYPES =
	[
		{key: 'xaxis', label: 'X Axis'},
		{key: 'yaxis', label: 'Y Axis'},
		{key: 'zaxis', label: 'Z Axis'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.FLOAT, 'amount', 0.0, { minValue: -180, maxValue: 180, units: PARAM_UNITS.DEGREES });
		this.addInput(PARAM_TYPE.DROPDOWN, 'axis', NodeBend.AXIS_TYPES[1].key, { dropdownOptions: NodeBend.AXIS_TYPES });

		this.addInput(PARAM_TYPE.FLOAT, 'offset_along', 0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'offset_perp', 0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.FLOAT, 'orientation', 0.0, { minValue: -180, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'bend';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		const fDegAmount = inputValues['amount'];
		// Avoid division by zero
		if(Math.abs(fDegAmount) < 1e-4)
			return pGeoList;

		const fOrientationDegs = inputValues['orientation'] - 90;
		const fOrientationRads = fOrientationDegs/180.0*Math.PI;

		let bbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);
		const strAxis = inputValues['axis'];

		const fAlongInterp = inputValues['offset_along']/100.0;
		const fPerpInterp = inputValues['offset_perp']/100.0;

		const bboxMax = bbox.maximumWorld;
		const bboxMin = bbox.minimumWorld;
		const bboxCenter = bboxMax.add(bboxMin).scale(0.5);
		const bboxHalfSize = bboxMax.subtract(bboxCenter);
		
		let pCoordSystem = GeoUtils.getCoordSystemForBendAxis(strAxis);
		pCoordSystem.sideAxis = Utils3D.rotatePointAroundAxis(pCoordSystem.rotAxis, fOrientationRads, pCoordSystem.sideAxis);
		pCoordSystem.dirAxis = Utils3D.rotatePointAroundAxis(pCoordSystem.rotAxis, fOrientationRads, pCoordSystem.dirAxis);

		let fPerpLength = BABYLON.Vector3.Dot(bboxHalfSize, pCoordSystem.sideAxis)*fPerpInterp;
		let fAlongLength = BABYLON.Vector3.Dot(bboxHalfSize, pCoordSystem.dirAxis)*fAlongInterp;
		let vecRelativeToPoint = bboxCenter.add(pCoordSystem.sideAxis.scale(fPerpLength)).add(pCoordSystem.dirAxis.scale(fAlongLength));
		
		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			const pNode = this.getGraph().getNode(pSrcMesh.parentNodeId);
			const bIsImportedMesh = pNode.getType() === 'file';

			GeoUtils.bendSingleMesh(pSrcMesh, fDegAmount, fOrientationDegs, strAxis, bbox.minimumWorld, bbox.maximumWorld, vecRelativeToPoint, bIsImportedMesh);
		}

		return pGeoList;
	}
}